import styled from 'styled-components';

import { Table } from 'components/Table';

export const CTable = styled(Table)<{
  isLoading: boolean;
  hideLevel0: boolean;
}>`
  width: 100%;

  ${props =>
    props.hideLevel0
      ? `
      .ant-table-row.ant-table-row-level-0 {
        display: none;
      }

      .ant-table-expanded-row.ant-table-expanded-row-level-1 {
        .ant-table-row.ant-table-row-level-0 {
          display: table-row !important;
        }
      }
    `
      : ''}

  .ant-table-expanded-row > td {
    border: none;
  }

  .ant-table-expanded-row {
    .ant-table {
      margin: 0px !important;
    }
  }

  .column-invitation {
    width: 100%;
  }

  .hide-column-table {
    // display: none !important;
    border-right: 1px solid #ffffff !important;
    background-color: #ffffff !important;
  }

  .ant-table-container {
    border-top-left-radius: 0px !important;
    border-top-right-radius: 0px !important;
    border-left: 0px solid #9f9f9f !important;
  }

  table {
    border-top: 0px solid #9f9f9f !important;
    border-top-left-radius: 0px !important;
    border-top-right-radius: 0px !important;
  }

  .ant-table-tbody > tr > td:not(.hide-column-table) {
    border-right: 1px solid #000000 !important;
  }

  .ant-table-tbody > tr > td {
    border-bottom: 1px solid #000000 !important;

    &:first-child {
      border-left: 1px solid #000000 !important;
    }
  }

  .ant-table-thead > tr:first-child > th:first-child {
    border-top-left-radius: 0px !important;
    border-left: 1px solid #000000 !important;
  }

  .ant-table-thead > tr > th {
    border-bottom: 1px solid #000000 !important;
    border-right: 1px solid #000000 !important;
    border-top: 1px solid #000000 !important;
    border-left: 1px solid #ffffff !important;

    font-weight: 600;

    &:last-child {
      border-top-right-radius: 0px !important;
    }
  }

  thead {
    tr:nth-child(2) {
      th {
        border-top: 0px !important;
        border-left: 0px !important;
      }
    }
  }

  .child-table > .ant-table-thead > tr > th:first-child {
    border-left: 0px !important;
  }

  .ant-table-expanded-row > .ant-table-cell:first-child {
    border: none !important;
    padding: 0px !important;
  }

  .ant-table-cell {
    font-weight: ${props => props.theme.font.weight.bold} !important;
    padding: 4px !important;
  }

  .ant-table-tbody {
    tr {
      position: relative;

      .actions-row {
        position: absolute;
        bottom: 0;
        left: 0;

        transform: translate(-1px, 100%);
        display: none;
        z-index: 10;
      }

      &:hover {
        .actions-row {
          display: flex;
        }
      }
    }

    tr:nth-child(2n + 0) {
      td {
        background-color: #f8f8f8;
      }
    }

    tr:nth-child(2n + 1) {
      td {
        background-color: #ffffff;
      }
    }
  }

  .first-category-column {
    border-right: 0px !important;
  }
`;

export const WrapperAbsolute = styled.div`
  width: 600px;
  background: #ffffff;
  position: absolute;
  left: 4px;
  z-index: 1;
`;
